const resources = { backToTop: 'Back to Top' };

module.exports = function getResource(label) {
    return resources[label];
};
